export const defaultWeapons = [
  {
    name: 'War Axe',
    damageString: '1d12',
    damageTypes: ['Edged'],
    hands: 1,
    range: 5,
    strReq: 6,
    combatStyles: ['Versatile'],
    specialzations: ['Axes'],
    icon: 'gi-war-axe'
  },
  {
    name: 'Battle Axe',
    damageString: '2d8',
    damageTypes: ['Edged'],
    hands: 2,
    range: 5,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Axes'],
    icon: 'gi-battle-axe'
  },
  {
    name: 'Great Axe',
    damageString: '1d20',
    damageTypes: ['Edged'],
    hands: 2,
    range: 5,
    strReq: 9,
    combatStyles: ['Heavy'],
    specialzations: ['Axes'],
    icon: 'gi-halberd'
  },
  {
    name: 'Longbow',
    damageString: '1d10',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 80,
    strReq: 4,
    combatStyles: ['Versatile'],
    specialzations: ['Bows'],
    icon: 'gi-bow-arrow'
  },
  {
    name: 'Crossbow',
    damageString: '2d8',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 80,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Crossbows'],
    icon: 'gi-crossbow'
  },
  {
    name: 'Cestus',
    damageString: '1d12',
    damageTypes: ['Blunt'],
    hands: 1,
    range: 5,
    strReq: 6,
    combatStyles: ['Versatile'],
    specialzations: ['Brawling'],
    icon: 'gi-mailed-fist'
  },
  {
    name: 'Pistol',
    damageString: '1d4',
    damageTypes: ['Piercing'],
    hands: 1,
    range: 40,
    strReq: 2,
    combatStyles: ['Light'],
    specialzations: ['Handguns'],
    icon: 'gi-pistol-gun'
  },
  {
    name: 'SMG',
    damageString: '1d4',
    damageTypes: ['Piercing'],
    hands: 1,
    range: 40,
    strReq: 2,
    combatStyles: ['Light'],
    specialzations: ['Machine Guns'],
    icon: 'gi-mp-40'
  },
  {
    name: 'Machine Gun',
    damageString: '1d12',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 60,
    strReq: 4,
    combatStyles: ['Versatile'],
    specialzations: ['Machine Guns'],
    icon: 'gi-mp-5'
  },
  {
    name: 'War Hammer',
    damageString: '1d12',
    damageTypes: ['Blunt'],
    hands: 1,
    range: 5,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Hammers'],
    icon: 'gi-warhammer'
  },
  {
    name: 'Maul',
    damageString: '2d8',
    damageTypes: ['Blunt'],
    hands: 2,
    range: 5,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Hammers'],
    icon: 'gi-flat-hammer'
  },
  {
    name: 'Giant Hammer',
    damageString: '1d20',
    damageTypes: ['Blunt'],
    hands: 2,
    range: 5,
    strReq: 9,
    combatStyles: ['Heavy'],
    specialzations: ['Hammers'],
    icon: 'gi-thor-hammer'
  },
  {
    name: 'Dagger',
    damageString: '1d6',
    damageTypes: ['Piercing'],
    hands: 1,
    range: 5,
    strReq: 2,
    icon: 'gi-broad-dagger'
  },
  {
    name: 'Spear',
    damageString: '1d12',
    damageTypes: ['Piercing'],
    hands: 1,
    range: 10,
    strReq: 6,
    combatStyles: ['Versatile'],
    specialzations: ['Polearms'],
    icon: 'gi-barbed-spear'
  },
  {
    name: 'Glaive',
    damageString: '2d8',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 10,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Polearms'],
    icon: 'gi-glaive'
  },
  {
    name: 'Sarissa',
    damageString: '1d20',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 10,
    strReq: 9,
    combatStyles: ['Heavy'],
    specialzations: ['Polearms'],
    icon: 'gi-spartan'
  },
  {
    name: 'Carbine',
    damageString: '1d10',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 60,
    strReq: 4,
    combatStyles: ['Versatile'],
    specialzations: ['Rifles'],
    icon: 'gi-steyr-aug'
  },
  {
    name: 'Long Gun',
    damageString: '2d8',
    damageTypes: ['Piercing'],
    hands: 2,
    range: 80,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Rifles'],

    icon: 'gi-winchester-rifle'
  },
  {
    name: 'Shotgun',
    damageString: '2d8',
    damageTypes: ['Blunt'],
    hands: 2,
    range: 20,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Shotguns'],
    icon: 'gi-sawed-off-shotgun'
  },
  {
    name: 'Longsword',
    damageString: '1d12',
    damageTypes: ['Edged'],
    hands: 1,
    range: 5,
    strReq: 6,
    combatStyles: ['Versatile'],
    specialzations: ['Swords'],
    icon: 'gi-pointy-sword'
  },
  {
    name: 'Bastard Sword',
    damageString: '2d8',
    damageTypes: ['Edged'],
    hands: 2,
    range: 5,
    strReq: 6,
    combatStyles: ['Heavy'],
    specialzations: ['Swords'],
    icon: 'gi-spinning-sword'
  },
  {
    name: 'Great Sword',
    damageString: '1d20',
    damageTypes: ['Edged'],
    hands: 2,
    range: 5,
    strReq: 9,
    combatStyles: ['Heavy'],
    specialzations: ['Swords'],
    icon: 'gi-relic-blade'
  },
  {
    name: 'Lash',
    damageString: '1d6',
    damageTypes: ['Edged'],
    hands: 1,
    range: 20,
    strReq: 2,
    combatStyles: ['Light'],
    specialzations: ['Whips'],
    icon: 'gi-whip'
  },
  {
    name: 'Great Lash',
    damageString: '1d12',
    damageTypes: ['Edged'],
    hands: 1,
    range: 20,
    strReq: 6,
    combatStyles: ['Versatile'],
    specialzations: ['Whips'],
    icon: 'gi-whip'
  },
  {
    name: 'Casting Wand',
    damageString: '1d4',
    damageTypes: ['Piercing'],
    hands: 1,
    range: 5,
    strReq: 2,
    combatStyles: ['Light'],
    icon: 'gi-fairy-wand'
  },
  {
    name: 'Casting Staff',
    damageString: '1d10',
    damageTypes: ['Blunt'],
    hands: 1,
    range: 10,
    strReq: 6,
    combatStyles: ['Versatile'],
    specialzations: ['Polearms'],
    icon: 'gi-wizard-staff'
  }
]
